<div class="organization-section" *ngIf="orgs?.length">
  <div class="organization-title">
    <mat-icon>business</mat-icon>
    <span>{{ "accountMenu.myOrgs" | translate }}</span>
  </div>

  <div class="organization-list">
    <ng-container *ngFor="let org of orgs; let i = index">
      <div
        *ngIf="isCurrentOrg(org)"
        class="organization-item active"
        aria-current="true"
        [id]="idPrefix + i"
        [matTooltip]="'organizationSwitcher.current' | translate: { name: org.name }"
      >
        <span class="organization-name">{{ org.name }}</span>
        <mat-icon class="organization-status">check_circle</mat-icon>
      </div>

      <button
        *ngIf="!isCurrentOrg(org)"
        type="button"
        class="organization-item"
        [id]="idPrefix + i"
        [matTooltip]="'organizationSwitcher.switchTo' | translate: { name: org.name }"
        [attr.aria-label]="'organizationSwitcher.switchTo' | translate: { name: org.name }"
        (click)="onOrgChange(org)"
      >
        <span class="organization-name">{{ org.name }}</span>
        <mat-icon class="organization-status">swap_horiz</mat-icon>
      </button>
    </ng-container>
  </div>
</div>
